import Vue from "vue";
import Vuex from "vuex";
import Firebase from "firebase";

Vue.use(Vuex);

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC2Cc5z-6ZihoEuyVHMwcfapiiG8qyg_mk",
  authDomain: "sonar-2.firebaseapp.com",
  databaseURL: "https://sonar-2.firebaseio.com",
  projectId: "sonar-2",
  storageBucket: "sonar-2.appspot.com",
  messagingSenderId: "893806588715"
};

// Initialize firebase
Firebase.initializeApp(firebaseConfig);

export const store = new Vuex.Store({
  state: {
    isAppLoading: true,
    user: {},
    isCurrentUserAdmin: false,
    adminModeOn: false,
    usersList: [],
    clientsList: [],
    projectsList: [],
    roomsList: [],
    measurementsList: [],
    advicevaluesList: [],
    productsList: [],
    productsAmount: 0,
    currentClientPage: {},
    modals: {
      client: {
        create: {
          shown: false
        },
        edit: {
          shown: false
        }
      },
      project: {
        create: {
          shown: false
        },
        edit: {
          shown: false
        }
      },
      room: {
        create: {
          shown: false
        },
        edit: {
          shown: false
        }
      },
      measurement: {
        create: {
          shown: false
        },
        edit: {
          shown: false
        }
      },
      analysis: {
        view: {
          shown: false
        }
      },
      advice: {
        view: {
          shown: false
        }
      },
      assemblyChecklist: {
        view: {
          shown: false
        }
      },
      changelog: {
        view: {
          shown: false
        }
      },
      product: {
        edit: {
          shown: true
        }
      }
    }
  },
  getters: {
    getLoadingStatus: state => {
      return state.isAppLoading;
    },
    getUser: state => {
      return state.user;
    },
    getCurrentUserAdminStatus: state => {
      return state.isCurrentUserAdmin;
    },
    getAdminModeStatus: state => {
      return state.adminModeOn;
    },
    getClientsList: state => {
      return state.clientsList;
    },
    getProjectsList: state => {
      return state.projectsList;
    },
    getRoomsList: state => {
      return state.roomsList;
    },
    getMeasurementsList: state => {
      return state.measurementsList;
    },
    getUsersList: state => {
      return state.usersList;
    },
    getAdvicevaluesList: state => {
      return state.advicevaluesList;
    },
    getActiveAdvicevaluesList: state => {
      return state.advicevaluesList.filter(advicevalue => advicevalue.active);
    },
    getENVList: state => {
      return state.ENVList;
    },
    getProductsList: state => {
      return state.productsList;
    },
    getModalStates: state => {
      return state.modals;
    },
    getIsAnyModalOpen: state => {
      return (
        state.modals.client.create.shown ||
        state.modals.client.edit.shown ||
        state.modals.project.create.shown ||
        state.modals.project.edit.shown ||
        state.modals.room.create.shown ||
        state.modals.room.edit.shown ||
        state.modals.measurement.create.shown ||
        state.modals.measurement.edit.shown ||
        state.modals.advice.view.shown ||
        state.modals.assemblyChecklist.view.shown ||
        state.modals.changelog.view.shown
      );
    },
    getCurrentClientPage: state => {
      return state.currentClientPage;
    }
  },
  mutations: {
    setAppLoading: (state, trueOrFalse) => {
      state.isAppLoading = trueOrFalse;
    },
    setUser: state => {
      state.user = Firebase.auth().currentUser;
    },
    setCurrentUserAdmin: state => {
      state.isCurrentUserAdmin = true;
    },
    toggleAdminMode: state => {
      state.adminModeOn = !state.adminModeOn;
    },
    setClients: (state, clientsList) => {
      state.clientsList = clientsList;
    },
    setProjects: (state, projectsList) => {
      state.projectsList = projectsList;
    },
    setRooms: (state, roomsList) => {
      state.roomsList = roomsList;
    },
    setMeasurements: (state, measurementsList) => {
      state.measurementsList = measurementsList;
    },
    setUsers: (state, usersList) => {
      state.usersList = usersList;
    },
    setAdvicevalues: (state, advicevaluesList) => {
      const advicevaluesListArray = [];
      advicevaluesList.forEach(advicevalue => {
        advicevaluesListArray.push(advicevalue.data());
      });
      function sortAlphabetically(array, property) {
        return array.sort((valueA, valueB) => {
          if (valueA[property] < valueB[property]) {
            return -1;
          }
          if (valueA[property] > valueB[property]) {
            return 1;
          }
          return 0;
        });
      }
      state.advicevaluesList = sortAlphabetically(
        advicevaluesListArray,
        "label"
      );
    },
    setENV: (state, ENVList) => {
      state.ENVList = ENVList;
    },
    setProducts: (state, productsListAndAmount) => {
      state.productsList = productsListAndAmount[0];
      state.productsAmount = productsListAndAmount[1];
    },
    setModalShown: (state, modalData) => {
      state.modals[modalData.dataType][modalData.modalType].shown =
        modalData.shown;
    },
    closeAllModals: state => {
      state.modals.client.create.shown = false;
      state.modals.client.edit.shown = false;
      state.modals.project.create.shown = false;
      state.modals.project.edit.shown = false;
      state.modals.room.create.shown = false;
      state.modals.room.edit.shown = false;
      state.modals.measurement.create.shown = false;
      state.modals.measurement.edit.shown = false;
      state.modals.advice.view.shown = false;
      state.modals.assemblyChecklist.view.shown = false;
    },
    setCurrentClientPage: (state, data) => {
      state.currentClientPage = data;
    },
    setCurrentClientPageClient: (state, clientData) => {
      state.currentClientPage.client = clientData;
    },
    setCurrentClientPageClientProjects: (state, projects) => {
      state.currentClientPage.clientProjects = projects;
    },
    setCurrentClientPageProject: (state, projectData) => {
      state.currentClientPage.project = projectData;
    },
    setCurrentClientPageProjectRooms: (state, rooms) => {
      state.currentClientPage.clientRooms = rooms;
    },
    setCurrentClientPageRoom: (state, roomData) => {
      state.currentClientPage.room = roomData;
    },
    setCurrentClientPageRoomMeasurements: (state, measurements) => {
      state.currentClientPage.roomMeasurements = measurements;
    },
    setCurrentClientPageMeasurement: (state, measurementData) => {
      state.currentClientPage.measurement = measurementData;
    }
  },
  actions: {
    setUser: ({ commit }) => {
      commit("setUser");
    },
    // Fetching actions
    fetchAllData: ({ commit, dispatch }) => {
      return new Promise((resolve, reject) => {
        commit("setAppLoading", true);
        const fetchPromises = [
          /*
          dispatch("fetchClients"),
          dispatch("fetchProjects"),
          dispatch("fetchRooms"),
          dispatch("fetchMeasurements"),
          */
          dispatch("fetchUsers"),
          dispatch("fetchAdvicevalues"),
          dispatch("fetchENVAndProducts")
        ];
        Promise.all(fetchPromises)
          .then(() => {
            console.log("All fetch promises resolved");
            commit("setAppLoading", false);
            resolve();
          })
          .catch(error => {
            console.log("Error fetching data: ", error);
            reject();
          });
      });
    },
    fetchClients: ({ commit }) => {
      return new Promise((resolve, reject) => {
        Firebase.firestore()
          .collection("clients")
          .get()
          .then(querySnapshot => {
            const clientsList = [];
            querySnapshot.forEach(doc => {
              clientsList.push(doc);
            });
            commit("setClients", clientsList);
          })
          .then(() => {
            console.log("Done fetching clients");
            resolve();
          })
          .catch(error => {
            console.log("Error fetching clients:", error);
            reject(error);
          });
      });
    },
    fetchProjects: ({ commit }) => {
      return new Promise((resolve, reject) => {
        Firebase.firestore()
          .collection("projects")
          .get()
          .then(querySnapshot => {
            const projectsList = [];
            querySnapshot.forEach(doc => {
              projectsList.push(doc);
            });
            commit("setProjects", projectsList);
          })
          .then(() => {
            console.log("Done fetching projects");
            resolve();
          })
          .catch(error => {
            console.log("Error fetching projects:", error);
            reject(error);
          });
      });
    },
    fetchRooms: ({ commit }) => {
      return new Promise((resolve, reject) => {
        Firebase.firestore()
          .collection("rooms")
          .get()
          .then(querySnapshot => {
            const roomsList = [];
            querySnapshot.forEach(doc => {
              roomsList.push(doc);
            });
            commit("setRooms", roomsList);
          })
          .then(() => {
            console.log("Done fetching rooms");
            resolve();
          })
          .catch(error => {
            console.log("Error fetching rooms:", error);
            reject(error);
          });
      });
    },
    fetchMeasurements: ({ commit }) => {
      return new Promise((resolve, reject) => {
        Firebase.firestore()
          .collection("measurements")
          .get()
          .then(querySnapshot => {
            const measurementsList = [];
            querySnapshot.forEach(doc => {
              measurementsList.push(doc);
            });
            commit("setMeasurements", measurementsList);
          })
          .then(() => {
            console.log("Done fetching measurements");
            resolve();
          })
          .catch(error => {
            console.log("Error fetching measurements:", error);
            reject(error);
          });
      });
    },
    fetchUsers: ({ commit }) => {
      return new Promise((resolve, reject) => {
        Firebase.firestore()
          .collection("users")
          .get()
          .then(querySnapshot => {
            const usersList = [];
            querySnapshot.forEach(doc => {
              usersList.push(doc);
            });
            commit("setUsers", usersList);
          })
          .then(() => {
            console.log("Done fetching users");
            resolve();
          })
          .catch(error => {
            console.log("Error fetching users:", error);
            reject(error);
          });
      });
    },
    fetchAdvicevalues: ({ commit }) => {
      return new Promise((resolve, reject) => {
        Firebase.firestore()
          .collection("advicevalues")
          .get()
          .then(querySnapshot => {
            const advicevaluesList = [];
            querySnapshot.forEach(doc => {
              advicevaluesList.push(doc);
            });
            commit("setAdvicevalues", advicevaluesList);
          })
          .then(() => {
            console.log("Done fetching advicevalues");
            resolve();
          })
          .catch(error => {
            console.log("Error fetching advicevalues:", error);
            reject(error);
          });
      });
    },
    fetchENVAndProducts: ({ commit, state }) => {
      return new Promise((resolve, reject) => {
        Firebase.firestore()
          .collection("ENV")
          .get()
          .then(querySnapshot => {
            const ENVList = [];
            querySnapshot.forEach(doc => {
              ENVList.push(doc);
            });
            commit("setENV", ENVList);
          })
          .then(() => {
            console.log("Done fetching ENV");
            const url =
              "https://api.knack.com/v1/objects/object_2/records?rows_per_page=1000";
            fetch(url, {
              headers: {
                "X-Knack-REST-API-KEY": state.ENVList[0].data().value,
                "X-Knack-Application-Id": state.ENVList[1].data().value
              }
            })
              .then(knackResponse => {
                return knackResponse.json();
              })
              .then(value => {
                const productsList = value.records;
                const productsAmount = value.total_records;
                commit("setProducts", [productsList, productsAmount]);
                console.log("Done fetching products");
                resolve();
              })
              .catch(error => {
                console.log("Error fetching products:", error);
                reject(error);
              });
          })
          .catch(error => {
            console.log("Error fetching ENV:", error);
            reject(error);
          });
      });
    },
    // Creating actions
    createClient: ({ dispatch }, newClient) => {
      return new Promise((resolve, reject) => {
        Firebase.firestore()
          .collection("clients")
          .add(newClient)
          .then(() => {
            console.log("Done creating client");
            dispatch("fetchClients").then(() => {
              resolve();
            });
          })
          .catch(error => {
            console.log("Error creating client: ", error);
            reject();
          });
      });
    },
    createProject: ({ dispatch }, newProject) => {
      return new Promise((resolve, reject) => {
        Firebase.firestore()
          .collection("projects")
          .add(newProject)
          .then(() => {
            console.log("Done creating project");
            dispatch("fetchProjects").then(() => {
              resolve();
            });
          })
          .catch(error => {
            console.log("Error creating project: ", error);
            reject();
          });
      });
    },
    createRoom: ({ dispatch }, newRoom) => {
      return new Promise((resolve, reject) => {
        Firebase.firestore()
          .collection("rooms")
          .add(newRoom)
          .then(() => {
            console.log("Done creating room");
            dispatch("fetchRooms").then(() => {
              resolve();
            });
          })
          .catch(error => {
            console.log("Error creating room: ", error);
            reject();
          });
      });
    },
    createMeasurement: ({ dispatch }, newMeasurement) => {
      return new Promise((resolve, reject) => {
        Firebase.firestore()
          .collection("measurements")
          .add(newMeasurement)
          .then(() => {
            dispatch("fetchMeasurements").then(() => {
              console.log("Done creating measurement");
              resolve();
            });
          })
          .catch(error => {
            console.log("Error creating measurement: ", error);
            reject();
          });
      });
    },
    // Editing actions
    editClient: ({ dispatch }, clientData) => {
      return new Promise((resolve, reject) => {
        Firebase.firestore()
          .collection("clients")
          .doc(clientData.id)
          .set(clientData.body, { merge: true })
          .then(() => {
            console.log("Done editing client");
            dispatch("fetchClients").then(() => {
              resolve();
            });
          })
          .catch(error => {
            console.log("Error editing client: ", error);
            reject();
          });
      });
    },
    editProject: ({ dispatch }, projectData) => {
      return new Promise((resolve, reject) => {
        Firebase.firestore()
          .collection("projects")
          .doc(projectData.id)
          .set(projectData.body, { merge: true })
          .then(() => {
            console.log("Done editing project");
            dispatch("fetchProjects").then(() => {
              resolve();
            });
          })
          .catch(error => {
            console.log("Error editing project: ", error);
            reject();
          });
      });
    },
    editRoom: ({ dispatch }, roomData) => {
      return new Promise((resolve, reject) => {
        Firebase.firestore()
          .collection("rooms")
          .doc(roomData.id)
          .set(roomData.body, { merge: true })
          .then(() => {
            console.log("Done editing room");
            dispatch("fetchRooms").then(() => {
              resolve();
            });
          })
          .catch(error => {
            console.log("Error editing room: ", error);
            reject();
          });
      });
    },
    editMeasurement: ({ dispatch }, measurementData) => {
      return new Promise((resolve, reject) => {
        Firebase.firestore()
          .collection("measurements")
          .doc(measurementData.id)
          .set(measurementData.body, { merge: true })
          .then(() => {
            console.log("Done editing measurement");
            dispatch("fetchMeasurements").then(() => {
              resolve();
            });
          })
          .catch(error => {
            console.log("Error editing measurement: ", error);
            reject();
          });
      });
    },
    uploadFile: ({ dispatch }, fileData) => {
      return new Promise((resolve, reject) => {
        const storageRef = Firebase.storage().ref();
        const newImageRef = storageRef.child(`testfolder/${fileData.fileName}`);
        newImageRef
          .put(fileData.blob)
          .then(snapshot => {
            console.log("Uploaded file to Firebase Storage!", snapshot);
            resolve();
          })
          .catch(error => {
            console.log("Error uploading file: ", error);
            reject();
          });
      });
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js